import EventEmitter from '../../common/EventEmitter';
import SlidingStack from '../../common/utils/SlidingStack';
import { InternalEvents } from '../../events';
import { SourceType, TransferRecord } from './interfaces';

interface TransferMeta {
  type: SourceType;
}

export default class RetryPeerTracker {
  emitter: EventEmitter;
  stack: SlidingStack<TransferMeta>;
  constructor(eventEmitter: EventEmitter) {
    // keep last 10 records
    this.stack = new SlidingStack(10);
    this.emitter = eventEmitter;

    this.emitter.addEventListener(InternalEvents.TRANSFER_RECORD, evt => {
      const transfer = evt.data as TransferRecord;
      if (!transfer) {
        return;
      }
      this.addTransfer(transfer);
    });
  }

  addTransfer(transfer: TransferRecord): void {
    // for now we only care about successful records
    if (transfer.status) {
      this.stack.push({ type: transfer.type });
    }
  }

  shouldRetry(): boolean {
    // get assesment of the last few transfers. If mostly peered, 60%, then retry peers
    const sums = this.stack.items.reduce(
      (acc, nextItem) => {
        const { origin, cluster } = acc;
        switch (nextItem.type) {
          case SourceType.INGEST:
          case SourceType.GRID:
            return { cluster, origin: origin + 1 };
          default:
            return { origin, cluster: cluster + 1 };
        }
      },
      { origin: 0, cluster: 0 }
    );
    const total = sums.origin + sums.cluster;
    if (total <= 0) {
      return false;
    }
    const perc = sums.cluster / total;
    return perc >= 0.6;
  }
}
